export default {
  bezier: "cubic-bezier(0.15, 0.15, 0, 1)",
  bezierFramer: [0.15, 0.15, 0, 1],
}
